<template>
  <!-- Search Section -->
  <li class="nav-item search-container">
    <div class="search-box">
      <div class="search-input-group">
        <div v-show="!statusEnrollment">
          <label for="departamentDropdown">Departamento</label>
          <Dropdown
            id="departamentDropdown"
            v-model="selectedDepartament"
            :options="departments"
            optionLabel="lugar"
            optionValue="id"
            placeholder="Seleccione un departamento"
            :class="{ 'p-invalid': searchError }"
            class="full-width"
          />
          <Button
            icon="pi pi-search"
            label="Buscar"
            @click="findRue"
            :loading="searchLoading"
          />
        </div>

        <!-- <Button
          icon="pi pi-file"
          label="Reporte Clasificados"
          severity="success"
          v-show="statusEnrollment"
          @click="downloadReport"
          :loading="searchLoading"
        /> -->
      </div>
      <small class="p-error" v-if="searchError">{{ searchError }}</small>
    </div>
  </li>
</template>

<script setup>
import { ref } from "vue";

const emit = defineEmits(["selectSchool", "getReport"]);

const props = defineProps({
  statusEnrollment: Boolean,
  departments: Array,
});

// Search functionality
const selectedDepartament = ref(null);
const searchError = ref("");
const searchLoading = ref(false);

const findRue = async () => {
  if (!selectedDepartament.value) {
    searchError.value = "Por favor seleccione un departamento";
    return;
  }
  emit("selectSchool", selectedDepartament.value);
};

function downloadReport() {
  emit("getReport");
}
</script>

<style scoped>
.search-container {
  padding: 1.5rem;
}

.search-box {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.search-input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.search-input-group :deep(.p-inputtext),
.search-input-group :deep(.p-button) {
  width: 100%;
  min-width: 0;
  flex: unset;
}

/* Registration Form Styles */
.registration-panel {
  margin-top: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.two-panel-grid {
  align-items: flex-start;
}

.info-panel {
  background: #f8fafc;
  border-radius: 1rem;
  padding: 2rem 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(60, 60, 60, 0.06);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.info-header {
  font-size: 1.2rem;
  font-weight: 600;
  color: #6366f1;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  .two-panel-grid {
    grid-template-columns: 1fr;
  }
  .info-panel,
  .upload-section {
    margin-bottom: 1.5rem;
  }
}

.upload-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background: #f8fafc;
  border-radius: 1rem;
  padding: 2rem 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(60, 60, 60, 0.06);
}

.upload-header {
  font-size: 1.2rem;
  font-weight: 600;
  color: #3b82f6;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.improved-upload-item {
  background: #fff;
  border-radius: 0.75rem;
  padding: 1.25rem 1rem;
  box-shadow: 0 1px 4px rgba(60, 60, 60, 0.04);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 1px solid #e0e7ef;
  transition: box-shadow 0.2s;
}
.improved-upload-item:hover {
  box-shadow: 0 4px 16px rgba(60, 60, 60, 0.1);
  border-color: #a5b4fc;
}

.upload-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.upload-label {
  font-weight: 500;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.selected-file {
  font-size: 0.95rem;
  color: #059669;
  background: #e0f2f1;
  border-radius: 0.5rem;
  padding: 0.2rem 0.7rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.upload-item :deep(.p-fileupload) {
  width: 100%;
}

.field {
  margin-bottom: 1.5rem;
}

.full-width {
  width: 100% !important;
  min-width: 0;
  box-sizing: border-box;
}

.upload-item :deep(.p-fileupload) {
  width: 100% !important;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-color-secondary);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid var(--surface-border);
}

.p-error {
  color: var(--red-500);
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
/* Ensure SweetAlert2 popup is always above dialogs */
.swal2-container {
  z-index: 3000 !important;
}
</style>
